<template>
  <div class="terms_of_service">
    <h2>服務條款</h2>
    <p>
      歡迎瀏覽金牌王國（下稱「本公司」）
      的網站。使用本網站前，敬請細閱此通知及服務條款。 因為使用本網站
      （或其任何部分） 即表示 閣下已閱讀此法定通知及服務條款，以及
      閣下不可撤銷及無條件地接受及同意受此法定通知及服務條款中的條款及條件約束。
    </p>
    <div class="terms">
      <h3>一般聲明</h3>
      <p>
        此網站所提供的資訊、服務及產品並不是在所有地域均可享用。只有適用法律容許之人士，才可瀏覽此網站的資訊及/或接受其提供的服務及產品。瀏覽此網站之人士，須確保其知悉及遵守有關的適用限制，及自行負責查證其所在地域的法律是否容許其瀏覽此網站及/或使用有關服務。
      </p>
      <p>
        此網站所包含的資料袛供一般性參考用及均以「如原狀」情況提供，本公司並不對該等資料作任何保證，另本公司可在毋須事前通知的情況下，隨時更改該等資料。
      </p>
      <p>
        本公司經已作出一切合理安排，以確保本網站上所提供的資料均為正確而最新。
        不過，本公司於此豁免所有隱含或明示之保證，
        並不會就本網站資料之正確或完整性作出聲明。本公司尤其是不會對本網站的內容，或其中之任何或相連內容負責，其中包括而不限於任何錯誤、謬誤、紕漏、侵權、誹謗、虛假或其他可觸犯或導致任何申索或投資之資料或紕漏。
      </p>
      <p>
        本網站所包含的資料並不意圖構成購買本公司發行的任何證券要約或唆使或不應視為向瀏覽人士提出任何建議。
      </p>
      <p>
        閣下於此確認及接納 閣下乃於風險自負的情況下使用本網站。
        本公司不保證本網站所提供的資料沒有任何錯誤、遺漏、不確，及有關本網址之使用或不能使用，或因本網站之運作中斷、缺陷、運作或傳送之阻延、或系統失靈而招致任何人士損失或開支，本公司概不負責。
      </p>
    </div>
    <div class="terms">
      <h3>互聯網通訊</h3>
      <p>
        於互聯網上傳遞之訊息並不保證絕對保密。閣下因透過互聯網向本公司傳送訊息，或要求本公司透過互聯網向其發出之訊息如有任何延誤、損失、變更、改動或訛誤，本公司對因此而引致之任何損失概不負責。本公司亦對使用此網站而招致之任何直接、間接、特別或連帶之損失不負任何責任。
      </p>
      <p>
        互聯網通訊可能會因互聯網之開放性質或其他原因或網上交通流量或數據傳送失誤而導致信息中斷、消失或傳送延誤，導致使用者直接或間接的困擾與損失,本公司不負擔補償義務與賠償責任。
      </p>
    </div>
    <div class="terms">
      <h3>知識產權</h3>
      <p>
        本網站內提供的任何資訊，包括但不限於文字、美術作品、圖標、圖像及商標，均受本公司擁有或管控的版權、商標或其他知識產權所保護。在未得本公司發出的事先書面許可前，
        閣下不得以任何方式就任何目的將本網站的內容或其任何部份複印、複製、再刊發、上載、下載、載錄、傳送、儲存於檢索系統內、變更、更改、向公眾顯示或分發；惟
        閣下可將網頁內顯示的材料下載，作非商業性家居及個人使用，但必須維持所有版權、商標及其他所有權通知完整無損。
      </p>
    </div>
    <div class="terms">
      <h3>連線網頁</h3>
      <p>
        本網站可能載有通往其他網址或網頁的連線點，此等網址或網頁並非由本公司設立或管控，本公司就此概不承擔任何責任。每當閣下啟動任何此等連線網址或網頁，即已離開本公司的網站，而閣下瀏覽任何該等網址或網頁均須自承風險，本公司概不負責，亦不會就此承擔任何責任。
      </p>
    </div>
    <div class="terms">
      <h3>不可抗力</h3>
      <p>
        因應國際牌價波動與實體供需狀況，若遇有不可抗力或特殊情事，本公司有權暫停所有實體交易，且有權選擇取消交易退還當初客戶下單購買時的所有金額。
      </p>
    </div>
    <div class="terms">
      <h3>訂單最終決定權</h3>
      <p>
        因國際貴金屬牌價浮動之因素，商品價格會不斷即時更新，如遇到系統故障、公告價與國際行情明顯不符合時，商品售價依照國際行情並加上鑄造費用為準，本公司保有最終商品價格履行與否的權利且使用者願意無條件接受本公司的最終決定。另若因國際鑄造廠任何出貨延遲等不可空因素，本公司保有最終商品交割與否的權利且使用者願意無條件接受本公司的最終決定。若消費者曾有棄單紀錄的狀況，本公司有拒絕交易的權利且消費者願意無條件接受本公司的最終決定。
      </p>
    </div>
    <div class="terms">
      <h3>準據法與管轄</h3>
      <p>
        本條款之解釋、效力、履行及其他未盡事宜，悉依中華民國法律。本條款所生之任何爭議、糾紛或訴訟，雙方同意以台灣台南地方法院為第一審理管轄法院。
      </p>
    </div>
    <div class="terms">
      <h3>變更</h3>
      <p>
        本公司有權（惟並無義務必須）按其絕對酌情決定對本網站及所載的任何資料，包括條款及條件，進行檢討、編輯或以任何其他方式作出變更，毋需另行通知。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsOfService",
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.terms_of_service {
  padding: 140px 6.2% 60px 6.2%;
  padding-top: 140px;
  text-align: left;
  color: $secondaryDeepColor1;
  font-size: 17px;
  h2 {
    font-size: 35px;
    font-weight: 600;
    letter-spacing: 2px;
    color: $primaryDeepColor;
    margin-top: 0;
  }
  h3 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 0;
  }
  p {
    line-height: 30px;
  }
}
.terms {
  & > p:first-of-type {
    margin-top: 0;
  }
}
</style>
